import { mapApplePayCardType } from 'utils/payment/map-apple-pay-card-type';

import { ICommitOptions } from '../use-commit-order';

/**
 * This function needed for the TH POS in order to commit an order successfully.
 * It is used to override the Credit Card Type to the one used while making an Apple Pay purchase.
 * Instead of sending the credit type of 'APPLE_PAY', we're sending the underlying credit card type used for the purchase.
 * If the user is paying with a Credit Card, we don't override and we're sending the credit type used.
 */
export const mapCardType = (options: ICommitOptions) => {
  // If it's not an Apple Pay transaction, keep the creditType from the options
  if (!options?.applePayDetails) {
    return options.creditType;
  }
  // Otherwise, map the Apple Pay card type to our CardType enum
  const mappedCardType = mapApplePayCardType(
    options?.applePayDetails?.paymentMethodData?.paymentType
  );
  // Override the credit type on the commit input & remove the paymentMethodData from the applePayDetails object
  return mappedCardType;
};
